import { AfterViewInit, Component, OnInit } from '@angular/core';
import { NgxSpinnerService } from "ngx-spinner";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { ApplicationService } from "../_services/application/application.service";
import { Notification } from "../_models/notification";
import { GuiService } from "../_services/gui-service/gui.service";

@Component({
  selector: 'app-event-alarms-dialog',
  templateUrl: './notifications-dialog.component.html',
  styleUrls: ['./notifications-dialog.component.css']
})
export class NotificationsDialogComponent implements AfterViewInit {
  public notifications: Array<Notification> = new Array<Notification>();

  constructor(private spinner: NgxSpinnerService,
    public activeModal: NgbActiveModal,
    private guiService: GuiService) {
  }

  ngAfterViewInit() {
  }

  loadNotifications() {

  }

}
